$(document).ready(function() {
    let dataTables = $('.data-tables');
    dataTables.DataTable({
        language: {
            url: '//cdn.datatables.net/plug-ins/1.10.10/i18n/Slovak.json'
        },
        columnDefs: [
            {
                targets: 'model-options-header',
                orderable: false,
            },
            {
                targets: 'datatables-details-control',
                orderable: false,
            }
        ],
        order: [],
        stateSave: true
    });

    dataTables.find(".datatables-details-control i").addClass("fa fa-plus-circle");

    dataTables.on('click', 'td.datatables-details-control', function () {
        let tr = $(this).closest('tr');
        let row = $(this).closest('table.data-tables').DataTable().row( tr );

        if ( row.child.isShown() ) {
            // This row is already open - close it
            row.child.hide();
            tr.find(".datatables-details-control i").addClass("fa-plus-circle").removeClass('fa-minus-circle');
        }
        else {
            // Open this row
            row.child(tr.find('.additional-data').html()).show();
            tr.find(".datatables-details-control i").addClass("fa-minus-circle").removeClass('fa-plus-circle');
        }
    });
});